require('../../modules/es6.object.seal');
module.exports = require('../../modules/_core').Object.seal;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/seal.js
// module id = 805
// module chunks = 1